import {Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Question} from '../../models/underwriter.model';

@Component({
    selector: 'app-question-odometer-reading',
    templateUrl: './question-odometer-reading.component.html',
    styleUrls: ['./question-odometer-reading.component.scss'],
    standalone: false
})
export class QuestionOdometerReadingComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<any>();
  @ViewChildren('odoInput') odoInputs!: QueryList<ElementRef<HTMLInputElement>>;

  controlNames = ['valueOne', 'valueTwo', 'valueThree', 'valueFour', 'valueFive', 'valueSix'];
  odometerForm = new FormGroup({
    valueOne: new FormControl(''),
    valueTwo: new FormControl(''),
    valueThree: new FormControl(''),
    valueFour: new FormControl(''),
    valueFive: new FormControl(''),
    valueSix: new FormControl('', Validators.required)
  });
  constructor() { }

  ngOnInit(): void {
    if(this.question?.answer !== undefined && this.question?.answer !== '' && this.question.answer !== null){
      let reading: any;
      try { reading = JSON.parse(this.question.answer); } catch { }
      if (!reading) { return; }
      if(reading?.valueOne != null && reading?.valueOne !== undefined){
        this.odometerForm.controls.valueOne.setValue(reading.valueOne);
      }
      if(reading?.valueTwo != null && reading?.valueTwo !== undefined){
        this.odometerForm.controls.valueTwo.setValue(reading.valueTwo);
      }
      if(reading?.valueThree != null && reading?.valueThree !== undefined){
        this.odometerForm.controls.valueThree.setValue(reading.valueThree);
      }
      if(reading?.valueFour != null && reading?.valueFour !== undefined){
        this.odometerForm.controls.valueFour.setValue(reading.valueFour);
      }
      if(reading?.valueFive != null && reading?.valueFive !== undefined){
        this.odometerForm.controls.valueFive.setValue(reading.valueFive);
      }
      if(reading?.valueSix != null && reading?.valueSix !== undefined){
        this.odometerForm.controls.valueSix.setValue(reading.valueSix);
      }
    }
    this.onChanges();
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Only allow numeric input
    if (value && !/^\d$/.test(value)) {
      input.value = '';
      return;
    }

    // Auto-tab to next input if a digit was entered
    if (value && index < 5) {
      const inputs = this.odoInputs.toArray();
      if (inputs[index + 1]) {
        inputs[index + 1].nativeElement.focus();
      }
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;

    // Handle backspace - move to previous input if current is empty
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const inputs = this.odoInputs.toArray();
      if (inputs[index - 1]) {
        inputs[index - 1].nativeElement.focus();
      }
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 6);

    if (digits.length > 0) {
      const inputs = this.odoInputs.toArray();

      digits.split('').forEach((digit, i) => {
        if (i < 6) {
          this.odometerForm.get(this.controlNames[i])?.setValue(digit);
        }
      });

      // Focus the next empty input or the last one
      const nextEmptyIndex = digits.length < 6 ? digits.length : 5;
      if (inputs[nextEmptyIndex]) {
        inputs[nextEmptyIndex].nativeElement.focus();
      }
    }
  }

  onChanges(){
    this.odometerForm.valueChanges.subscribe(() => {
      var valueOne = parseInt(this.odometerForm.get('valueOne')?.value);
      var valueTwo = parseInt(this.odometerForm.get('valueTwo')?.value);
      var valueThree = parseInt(this.odometerForm.get('valueThree')?.value);
      var valueFour = parseInt(this.odometerForm.get('valueFour')?.value);
      var valueFive = parseInt(this.odometerForm.get('valueFive')?.value);
      var valueSix = parseInt(this.odometerForm.get('valueSix')?.value);
      if(this.odometerForm.valid){
        var values = [];
        var value = {valueOne: valueOne, valueTwo: valueTwo, valueThree: valueThree, valueFour: valueFour, valueFive: valueFive, valueSix: valueSix};
        values.push(value);
        this.question.answer = JSON.stringify(value);
        this.questionAnswer.emit(this.question);
      }
    });
  }


}
